"use client";

import { useRef } from "react";
import BancolombiaFlow from "./bankFlows/BancolombiaFlow";
import DaviplataFlow from "./bankFlows/DaviplataFlow";
import NequiFlow from "./bankFlows/NequiFlow";

const BankFlow = ({
  bankValue,
  isDesktop,
  prevGeneral,
  onComplete,
  onBack,
  setProductAccount,
}) => {
  const hasCompleted = useRef(false); // ← guard

  const safeOnComplete = (flowData) => {
    if (hasCompleted.current) return; // ← bloquea ejecuciones posteriores
    hasCompleted.current = true;
    onComplete(flowData);
  };
  const props = {
    isDesktop,
    onComplete: safeOnComplete,
    prevGeneral,
    onBack,
    bankValue,
    setProductAccount,
  };

  switch (bankValue) {
    case 21:
      return <BancolombiaFlow {...props} />;
    case 30:
      return <NequiFlow {...props} />;
    case 31:
      return <DaviplataFlow {...props} />;
    default:
      return null;
  }
};

export default BankFlow;
